export function NoDataWrapperComponent(props: any){
    if(props.isNoData){
        return <div className="no-data">{props.noDataContent}</div>
    }
    return props.children
}